import React from "react";
import styled from "styled-components";
import { CircularProgress } from "@mui/material";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow-y: auto;
`;

export const ComponentLoader = ({
  loading,
  children,
}: React.PropsWithChildren<{ loading: boolean }>) => {
  return loading ? (
    <Container>
      <CircularProgress />
    </Container>
  ) : (
    <ContentContainer>{children}</ContentContainer>
  );
};

export const LoadComponent = ({
  loading,
  children,
}: React.PropsWithChildren<{ loading?: boolean }>) => {
  if (loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </div>
  );
};
